import { Organization } from '@organisations/data-access';

import { DashboardClause } from '../data-access/types/stats';

import { FilterOption } from './filter-options';

export const INDUSTRIAL_ORG_ROLE_NAMES = ['INDUSTRIAL', 'SAIPOL'] as const;

export function isIndustrialOrganisation(organisation: Organization): boolean {
  const roleName = organisation.role?.name;
  if (!roleName) {
    return false;
  }

  return INDUSTRIAL_ORG_ROLE_NAMES.includes(
    roleName as (typeof INDUSTRIAL_ORG_ROLE_NAMES)[number],
  );
}

export function getDefaultOrganisationIds(
  organisations: Organization[],
  clause: DashboardClause = 'gp',
): number[] {
  const flag: keyof Organization =
    clause === 'new' ? 'is_followed_ngp' : 'is_followed_gp';

  return organisations
    .filter((organisation) => organisation[flag])
    .map((organisation) => organisation.id);
}

export function buildOrganisationFilterOptions(
  organisations: Organization[],
  defaultOrganisationIds: number[],
): FilterOption[] {
  const defaultOrder = new Map(
    defaultOrganisationIds.map((id, index) => [id, index]),
  );

  return organisations
    .filter((organisation) => !isIndustrialOrganisation(organisation))
    .sort((left, right) => {
      const leftIndex = defaultOrder.get(left.id);
      const rightIndex = defaultOrder.get(right.id);

      if (leftIndex !== undefined && rightIndex !== undefined) {
        return leftIndex - rightIndex;
      }
      if (leftIndex !== undefined) {
        return -1;
      }
      if (rightIndex !== undefined) {
        return 1;
      }

      return left.name.localeCompare(right.name, 'fr');
    })
    .map(({ id, name }) => ({ id, name }));
}
